module.exports = __webpack_public_path__ + "img/root001.801d7927.png";